export var colorSchemes = function (scheme) {
    switch (scheme) {
        case 'information':
            return 'bg-foam border-matisee text-mirage';
        case 'success':
            return 'bg-frostee border-tropical-rain-forest text-mirage';
        case 'error':
            return 'bg-pippin border-well-read text-mirage';
        case 'important':
            return 'bg-colonial border-cognac text-mirage';
        case 'primary':
            return 'bg-minsk border-transparent text-white';
        case 'secondary':
            return 'bg-white border-minsk text-minsk';
        case 'tertiary':
            return 'bg-white border-transparent text-valhalla';
        case 'icon':
        case 'icon-no-hover':
            return 'bg-white border-none';
        default:
            return 'bg-alto border-alto text-mirage';
    }
};
